import store from 'store2';
import * as qs from '@zipit/ls-core-sdk/dist/querystring';
import isEmpty from 'lodash/isEmpty';
import indexOf from 'lodash/indexOf';
import { useRef, useEffect } from 'react';
import { parseQuery } from '@zipit/ls-portal-sdk/dist/clearQueryParams';

export const useInterval = (callback: Function, delay: number) => {
    const savedCallback = useRef<Function | null>(null);

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        function tick() {
            savedCallback.current?.();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
};


export const getDefaultRoute = (isAdmin: boolean): string => {
    return isAdmin ? '/devices' : '/home';
};

export const setAuthParams = () => {
    const query = parseQuery()

    if (query['code']) {
        store.set('lsOauthCode', query['code'])
    }
    if (query['state']) {
        store.set('lsOauthState', query['state'])
    }
}

export const parseNav = (url: string) => {
    const [path, search] = (url || '').split('?');
    const [pathname, hash] = (path || '')?.split('#');

    const queryStart = indexOf(hash, '?');
    const hashRoute = queryStart != -1
        ? hash.slice(0, queryStart)
        : hash;

    return {
        pathname: pathname || '',
        hash: '/' + (hashRoute || '').split('/').filter(part => !isEmpty(part)).join('/'),
        search,
        query: qs.parse(search) || {}
    };
}

export const removeLoader = () => {
    const loader = document.getElementById('loader');
    loader?.remove();

    const root = document.getElementById('root');
    if (root) {
        root.style.display = '';
    }
};
